import styled from '@xstyled/styled-components';
import React, { ChangeEventHandler } from 'react';
import Icon from './star.svg';

const ActiveIcon = styled(Icon)`
  stroke: accentDark;
  fill: accentDark;
`;

const HiddenRadio = styled.input`
  position: absolute;
  clip-path: polygon(0 0);
  padding: 0;
  width: 0;
  height: 0;
  margin: 0;
`;

const Label = styled.label`
  display: inline-block;
  padding: xs;
  cursor: pointer;
  /* &:focus-within {
    outline: solid 1px var(--color-grey-md);
  } */
`;

interface Props {
  onChange: ChangeEventHandler<HTMLInputElement>;
  active: boolean;
  value: number;
  name: string;
}

export const Star = ({ onChange, active, value, name }: Props) => (
  <Label>
    <HiddenRadio
      tabIndex={0}
      type="radio"
      name={name}
      value={value}
      onChange={onChange}
    />
    {active ? <ActiveIcon /> : <Icon />}
  </Label>
);
